import { ApiProperty } from '@nestjs/swagger'
import { IsArray, IsUUID } from 'class-validator'

export class TeachingStudentUserIdsBatchRequestDto {
  @ApiProperty({
    type: [String],
    description: 'Identifiants des enseignements (class ou group teaching)',
  })
  @IsArray()
  @IsUUID('4', { each: true })
  teachingIds: string[]
}
